window.userCommonAPI = {
    // 更新用户信息
    updateUserInfo: function (formData, callback) {
        var smarketMemberCookie = common.getCookie('smarketMember_498');
        //如果solution没有登录则不同步
        if(!smarketMemberCookie){
            console.log('solution未登录');
            return;
        }
        var smarketMember = JSON.parse(smarketMemberCookie);

        common.postJson(solution_host + '/api/account/updateMember',{
            "tenantId":window.cateData.tenantId,
            "schemaId":window.cateData.schemaId,
            "session": smarketMember.session,
            "url": window.location.href,
            "browseInfo": window.client.browseInfo,
            "formData":formData,
            "globalUserId": getUserInfo.options.globalUserId,
            'OCSESSID': common.getCookie('OCSESSID') || ''
        },function (res) {
            if (callback && typeof callback === 'function'){
                callback(res);
            }
        })
    }
}